// src/components/snapshot/strategy-brief/StrategyBriefOpportunityCard.tsx

import { ArrowUpRight } from 'lucide-react';

type Props = {
  title: string;
  systemInsight: string;
  implication: string;
  opportunity: string;
};

export function StrategyBriefOpportunityCard({ title, systemInsight, implication, opportunity }: Props) {
  return (
    <div className="rounded-2xl border border-[#E5E7EB] bg-white shadow-sm p-5 break-inside-avoid">
      <div className="flex items-start justify-between gap-3">
        <h3 className="text-base font-extrabold text-[#18365E] leading-snug">
          {title}
        </h3>
        <div className="h-8 w-8 rounded-xl bg-[#18365E]/8 flex items-center justify-center ring-1 ring-[#18365E]/10 flex-shrink-0">
          <ArrowUpRight className="h-3.5 w-3.5 text-[#18365E]" />
        </div>
      </div>

      <div className="mt-3 space-y-2.5">
        <div className="rounded-xl border border-[#E5E7EB] bg-[#F5F7FA] px-3.5 py-2.5">
          <div className="text-[10px] font-semibold tracking-wide uppercase text-[#717182]">
            System Insight
          </div>
          <p className="text-[12px] text-[#18365E] leading-relaxed mt-1 font-semibold">
            {systemInsight}
          </p>
        </div>

        <div>
          <div className="text-[10px] font-semibold tracking-wide uppercase text-[#717182]">
            Implication
          </div>
          <p className="text-[12px] text-[#18365E]/85 leading-relaxed mt-1">
            {implication}
          </p>
        </div>

        <div>
          <div className="text-[10px] font-semibold tracking-wide uppercase text-[#717182]">
            Opportunity
          </div>
          <p className="text-[12px] text-[#18365E] leading-relaxed mt-1 font-semibold">
            {opportunity}
          </p>
        </div>
      </div>
    </div>
  );
}
